<template>
  <i-overlay v-if="orderLoading" text="Loading order details..." />
  <div v-else>
    <i-order-details-draft
      v-if="showDraftOrderDetails"
      :orderDetails="orderDetails"
    />
    <i-order-details-purchase v-else :orderDetails="orderDetails" />
  </div>
</template>

<script>
import { fetchOrderDetails } from '@/services/supplierOrders'
import iOverlay from '@/components/Overlay'
import iOrderDetailsDraft from '../components/OrderDetailsDraft'
import iOrderDetailsPurchase from '../components/OrderDetailsPurchase'

export default {
  components: {
    iOverlay,
    iOrderDetailsDraft,
    iOrderDetailsPurchase
  },

  data() {
    return {
      orderDetails: [],
      orderLoading: true
    }
  },

  props: {
    orderId: String
  },

  computed: {
    isServiceOrder() {
      const items = this.orderDetails?.supplierOrderItems
      if (!items || !items.length) return false

      return items.every(
        (item) => item.productType === 'SERVICE' || !!item.retailerRequestedDate
      )
    },

    showDraftOrderDetails() {
      return this.orderDetails.status === 'DRAFT' && !this.isServiceOrder
    }
  },

  methods: {
    fetchOrder() {
      this.orderLoading = true
      fetchOrderDetails(this.orderId)
        .then((response) => {
          this.orderDetails = response
        })
        .finally(() => {
          this.orderLoading = false
        })
    }
  },

  mounted() {
    this.fetchOrder()
  }
}
</script>
